import { render } from "./patientDetail.vue?vue&type=template&id=52aaf243&scoped=true"
import script from "./patientDetail.vue?vue&type=script&lang=js"
export * from "./patientDetail.vue?vue&type=script&lang=js"

import "./patientDetail.vue?vue&type=style&index=0&id=52aaf243&scoped=true&lang=scss"
import "./patientDetail.vue?vue&type=style&index=1&id=52aaf243&lang=scss"

import exportComponent from "/mnt/jenkins/workspace/taoziprod-platform-webh5-remoteinquiry-master-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52aaf243"]])

export default __exports__